import React, { useState } from "react"
import classes from "./inputWithButton.module.scss"
import { useEffect } from "react";
import { useRef } from "react";
import { Button, COLORS, useGameSounds, useMediaQuery, useTranslate } from "@educaplay/core";
import { Check } from "@educaplay/core/Icons/Check";
import clsx from "clsx";
import { motion } from "framer-motion";
import { MAPA_SOUNDS } from "../../utils/constants";
import ButtonSend from "../ButtonSend";

export default function InputWithButton(props) {
    const { onSubmit } = props;

    const [inputValue, setInputValue] = useState('');
    const isInputEmpty = inputValue === '';
    const inputRef = useRef(null);
    const t = useTranslate();
    const gameSound = useGameSounds();
    const maxwidthMediaQuery = useMediaQuery("(max-width: 1025px)");

    const onChangeHandler = (e) => {
        if (e.target.value.trim().length > inputValue.length) gameSound.play(MAPA_SOUNDS.WRITE);
        setInputValue(e.target.value.trim());
    }

    const onSubmitHandler = (e) => {
        e.preventDefault();
        if (!inputValue) return;
        onSubmit(inputValue);
    }

    useEffect(() => {
        inputRef.current.focus();
    }, [])

    return (
        <motion.div
            className={classes.floatinputContainer}
            initial={{ opacity: 0, scale: 0.5, }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
        // transition={{ duration: 0.3, ease: "easeInOut" }}
        >
            <div
                className={classes.floatinput}
                onClick={ev => ev.stopPropagation()}
            >
                <form onSubmit={onSubmitHandler} spellCheck={false}>
                    <label className={classes.wrapper}>

                        {!maxwidthMediaQuery && (
                            <>
                                <input type="text" onChange={onChangeHandler} ref={inputRef} className={classes.input} />
                                <Button type={"submit"}
                                    icon={<Check color={COLORS.primaryDark2} />}
                                    className={clsx(classes.sendButtonDesktop, isInputEmpty && classes.sendButtonDesktopDisabled)}
                                    disabled={isInputEmpty}
                                >
                                    {t('common.settings.accept')}
                                </Button>
                            </>
                        )}

                        {maxwidthMediaQuery && (
                            <div className={classes.iframeContainer}>
                                <input type="text" onChange={onChangeHandler} ref={inputRef} className={classes.inputIframe} />
                                <div className={classes.actions}>
                                    <ButtonSend
                                        className={classes.sendButtonIframe}
                                        disabled={isInputEmpty}
                                    />
                                </div>
                            </div>
                        )}
                    </label>
                </form>
            </div>
        </motion.div>
    )
}